<template>
  <wg-modal :portal="true" @closeModal="$emit('closeFilter')">
    <div 
        slot="header"
        class="com-anm22-app-text-xl">
      {{ $anm22.strLang(lang, 'Filters', 'Filtri') }}
    </div>
    <div slot="body">
      <div
          class="wg-row"
          style="align-items:center;flex-wrap:nowrap;margin-bottom:20px;position:relative;"
          v-for="(filter,index) in filters"
          :key="'filter-'+index">
        <template v-if="filter.type === 'select' ">
          <div class="com-anm22-app-text-l">
            {{ filter.label }}
          </div>
          <div v-if="typeof filter.guide != 'undefined' && filter.guide" style="position:relative;">
            <img @click="$emit('showHelpDialog',filter.id)" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
            <world-help-label v-if="filter.showHelp" @closeLabel="filter.showHelp = false" :position="'under-right'" :text="descByFilter(filter)"></world-help-label>
          </div>
          <div class="com-anm22-horizontal-space" style="width:10px;"></div>
          <select 
              class="com-anm22-app-select"
              :value="-1 !== selFilters.findIndex(f => f.id == filter.id) ? selFilters.find(f => f.id == filter.id).value : ''"
              @change.stop="addFilter(filter.id, $event)">
            <option value="">
              {{ $anm22.strLang(lang, 'None', 'Nessun filtro') }}
            </option>
            <option 
                v-for="(val,index) in filter.values" 
                :key="filter.name + '-' + index"
                :value="val.value">
              {{ val.label }}
            </option>
          </select>
        </template>
        <template v-else>
          <div class="com-anm22-app-text-l">
            {{ filter.label }}
          </div>
          <div v-if="typeof filter.guide != 'undefined'  && filter.guide" style="position:relative;">
            <img @click="$emit('showHelpDialog',filter.id)" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
            <world-help-label v-if="filter.showHelp" @closeLabel="filter.showHelp = false" :position="filter.id == 'completed' ? 'left' : 'under-right'" :text="descByFilter(filter)"></world-help-label>
          </div>
          <div class="com-anm22-horizontal-space" style="width:10px;"></div>
          <input 
              :id="'check-'+filter.id"
              type="checkbox"
              style="display:none;"
              :value="-1 === selFilters.findIndex(f => f.id == filter.id) ? 1 : ''"
              @change.stop="addFilter(filter.id, $event)">
          <label class="checkbox-label" :for="'check-'+filter.id">
            {{ -1 !== selFilters.findIndex(f => f.id == filter.id) ? '✔' : '' }}
          </label>
        </template>
      </div>
      <div class="display-flex">
        <input 
          type="button" 
          class="small"
          :value="$anm22.strLang(lang, 'Apply', 'Applica')"
          @click="$emit('applyFilters', getFilters())">
      </div>
      <div v-if="activeGuide" style="position:relative;float:right;">
        <img @click="showFiltersHelp =! showFiltersHelp" class="com-anm22-app-img-s" style="margin-left:5px;opacity:0.6;cursor:pointer;" :src="$anm22.icons.getWorldIcon('helpIcon')">
        <world-help-label v-if="showFiltersHelp" :position="'up-left'" @closeLabel="showFiltersHelp = false" :text="'Aggiungi o togli i filtri per vedere più o meno progetti, in base al lavoro che devi fare o alla situazione che vuoi monitorare.'"></world-help-label>
      </div>
    </div>
  </wg-modal>
</template>

<script>
import { mapState } from 'vuex';
import WorldHelpLabel from "../../../world/spa/components/WorldHelpLabel.vue";

export default {
  props: {
    allFilters: Array,
    selected: Array,
    activeGuide: {
      type: Boolean,
      default: false
    }
    // showDialog: Boolean
  },
  data() {
    return {
      selFilters: this.selected.slice(),
      filters: this.allFilters.slice(),
      showFiltersHelp: false
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  methods: {
    addFilter(filterId, event) {
      const value = event.target.value;
      const index = this.selFilters.findIndex(f => f.id === filterId);
      if(-1 !== index) {
        if(value != '') {
          this.$set(this.selFilters, index, { id: filterId, value });
        } else {
          this.selFilters.splice(index, 1);
        }
      } else {
        if(value != '') {
          this.selFilters.push({ id: filterId, value });
        }
      }
    },
    closeLabel(filter) {
      filter.showHelp = false;
    },
    descByFilter(filter) {
      switch (filter.id) {
        case "personal":
          return "Visualizza solo i progetti con task assegnati al tuo utente"
        case "fs":
          return "Mostra i progetti con task pronti per essere eseguiti, consigliato l’utilizzo con il filtro task personali o postazione"
        case "job":
          return "Mostra solo progetti con task assegnati ad un determinato reparto"
        case "category":
          return "Mostra solo i progetti di una determinata categoria"
        case "completed":
          return "Mostra solo i progetti completati, fatturati o cancellati nell'anno in corso"
      }
    },
    getFilters() {
      return this.selFilters.slice();
    }
  },
  components: {
    WorldHelpLabel
  }
};
</script>

<style lang="scss" scoped>
.checkbox-label {
  margin-left: auto;
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
</style>
